import { usePermissionContext } from '@openx/utils/permission/context/PermissionContext';

export const useIsForecastingEnabled = (): boolean => {
  const { isOa, isPub, isDsp } = usePermissionContext();

  return Boolean(isOa || isPub || isDsp);
};
